// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"88d5f73c","183":"eae77e6f","458":"0fba1f53"}[chunkId] + ".chunk.js";
};